module.exports = __webpack_public_path__ + "img/Loading_icon.f4404720.gif";